<div class="modal"
     *ngIf="entity">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2 class="mb-0075 pb-0075 border-1 border-x-0 border-top-0">Shared contact info&hellip;</h2>
  <div class="w-100">
    <div class="results__entity flex flexJustify-between flexAlign-center p-0 bg-color--white mt-0"
         *ngIf="entity">
      <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                         [spotlightIcon]="entity.spotlightIcon"
                         [entityTypeId]="entity.entityTypeId"
                         [isUser]="entity?.linkedUserId"
                         size="sm">
      </app-entity-avatar>
      <div class="results__main">
        <app-entity-name [entity]="entity"></app-entity-name>
        <app-highlighted-topline [targetId]="entity.id"
                                 [targetType]="'Entity'"
                                 [campaignId]="entity.campaignContextId"
                                 [parentEntityId]="entity.id"
                                 [topline]="entity.appliedToplines?.item0"
                                 class="d-block w-auto">
        </app-highlighted-topline>
      </div>
    </div>
    <p class="mt-0100 mb-0100">
      <ng-container *ngIf="data.phone">
        The phone number
        <strong>“{{data.phone.number | phone}}{{data.phone.ext ? ' Ext. ' + data.phone.ext : ''}}”</strong>
      </ng-container>
      <ng-container *ngIf="data.email">
        The email address
        <strong>“{{data.email.email.trim()}}”</strong>
      </ng-container>
      is being shared by the {{entityTypeNameSingular}} above and at least one other {{entityTypeNameSingular}} below.
      If necessary, click
      “Merge” next to a {{entityTypeNameSingular}} below to combine duplicate entities.
    </p>
    <div class="ab-list-group-wrap ab-list-group-wrap--with-border">
      <div class="ab-list-group__head pl-0075 pb-0050 lh-normal">
        <span class="caps txt-12 color--gray txt-fw-500">Possible Duplicates</span>
      </div>
      <div style="max-height:300px;overflow-y:auto">
        <div class="ab-list-group">
          <div class="ab-list-item d-block"
               *ngFor="let sharingEntity of entityMatches">
            <div class="flex flexJustify-between flexAlign-center">
              <div class="results__entity flex flexJustify-between flexAlign-center p-0 bg-color--white mt-0">
                <app-entity-avatar [assessmentLevel]="sharingEntity.currentAssessmentLevel"
                                   [spotlightIcon]="sharingEntity.spotlightIcon"
                                   [entityTypeId]="sharingEntity.entityTypeId"
                                   size="sm">
                </app-entity-avatar>
                <div class="results__main break-word d-block">
                  <app-entity-name [entity]="sharingEntity"></app-entity-name>
                  <app-highlighted-topline [targetId]="sharingEntity.id"
                                           [targetType]="'Entity'"
                                           [campaignId]="sharingEntity.campaignContextId"
                                           [parentEntityId]="sharingEntity.id"
                                           [topline]="sharingEntity.appliedToplines?.item0"
                                           class="d-block w-auto mb-0012">
                  </app-highlighted-topline>
                  <button class="link link--noline caps pl-0 pr-0 txt-12"
                          (click)="detailsExpansionState[sharingEntity.id] = !detailsExpansionState[sharingEntity.id]">
                    <i class="fal fa-angle-down mr-0025"
                       [ngClass]="detailsExpansionState[sharingEntity.id] ? 'fa-angle-up' : 'fa-angle-down'"></i>View
                    Details
                  </button>
                </div>
              </div>
              <button class="btn btn--white"
                      (click)="onBeginMergeClicked(sharingEntity.id)">
                <i class="fal fa-code-merge mr-0050 d-none d-inline--sm"></i>Merge
              </button>
            </div>

            <div class="w-100 pb-0050"
                 *ngIf="detailsExpansionState[sharingEntity.id]">
              <app-entity-dob-table [entityId]="sharingEntity.id"
                                        [campaignId]="sharingEntity.campaignContextId"
                                        [readonly]="true"
                                        [showTaskDoneMark]="false"
                                        [showBad]="false"></app-entity-dob-table>

              <app-entity-language-table [entityId]="sharingEntity.id"
                                         [campaignId]="sharingEntity.campaignContextId"
                                         [readonly]="true"
                                         [showTaskDoneMark]="false"
                                         [showBad]="false"></app-entity-language-table>

              <app-entity-emails-table [entityId]="sharingEntity.id"
                                       [campaignId]="sharingEntity.campaignContextId"
                                       [readonly]="true"
                                       [showTaskDoneMark]="false"
                                       [showBad]="false"></app-entity-emails-table>

              <app-entity-phones-table [entityId]="sharingEntity.id"
                                       [campaignId]="sharingEntity.campaignContextId"
                                       [readonly]="true"
                                       [showTaskDoneMark]="false"
                                       [showBad]="false"></app-entity-phones-table>

              <app-entity-addresses-table [entityId]="sharingEntity.id"
                                          [campaignId]="sharingEntity.campaignContextId"
                                          [readonly]="true"
                                          [showTaskDoneMark]="false"
                                          [showBad]="false"></app-entity-addresses-table>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
